export default __webpack_public_path__ + "static/media/Megamind.289b6de9.png";